$.fn.live=function(event,callback){
	$(this).on(event,callback);
}

jQuery.ajaxSettings.traditional = true;
var mobile={
	pageType:'',
	productList:{},
	products:[],
	product: {
		id: 123,
		gallery:{
			all:0
		}
	},
	cart:{
		addedFrom:false,
		shops:{}
	}
}
function executeWhenMobi(){}
